export default "__VITE_ASSET__a5446021__"